import React from 'react';
import { Report } from '../../components/report/appraisal-report';
import { useParams } from 'react-router-dom';
import { ValuationApi } from '../../apis';
import { ValuationComparing } from '../../interfaces/valuation';
import useSWR from 'swr';
import { delay } from '../../utils';

const ReportScreen = () => {
  const { id } = useParams();
  const {
    data: payload,
    isLoading,
    isValidating,
    mutate,
  } = useSWR('swr.valuation.payload', async () => await ValuationApi.get(id!));

  React.useEffect(() => {
    const init = async () => {
      mutate(undefined, {
        revalidate: false,
      });

      await delay(300);
      mutate();
    };

    init();

    return () => {
      mutate(undefined, {
        revalidate: false,
      });
    };
  }, [mutate]);

  if (isLoading && isValidating) {
    return <div>Loading</div>;
  }

  if (!payload) {
    return <div>Loading</div>;
  }

  return <Report payload={payload as unknown as ValuationComparing} />;
};

export { ReportScreen };
